import React from 'react';

const Layout: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  return (
    <div className="relative min-h-screen">
      <video
        loop
        muted
        autoPlay
        playsInline
        className="fixed object-cover w-full h-full z-[-1]"
        style={{ filter: 'blur(12px) brightness(100%)' }}
      >
        <source src="https://r2-bios.e-z.host/0285143f-65e0-4125-929e-a407ba8e0c52/oebuo8yzhe.mp4" type="video/mp4" />
      </video>
      <div className="relative z-10 flex flex-col justify-center min-h-screen p-4">
        {children}
      </div>
    </div>
  );
};

export default Layout;